import type {Ref} from "vue"
import {DEBUG_COOKIE} from "~/libs/constants/constants";

export const useDebugStore = defineStore('debug', {
  state: () => {
    const state: {
      isArticlesLoading: Ref<boolean>
    } = {
      isArticlesLoading: ref(false),
    }
    return state
  },
  getters: {
    getIsArticleLoading(state): boolean {
      return this.isDebugEnabled && state.isArticlesLoading
    },
    isDebugEnabled(state): boolean {
      const debugCookie = useCookie(DEBUG_COOKIE)
      return !!debugCookie?.value
    }
  },
  actions: {

  },
})
